import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from 'react-router-dom';

import Home from './home';

import './app.scss';
import './global.scss';

/* Links */
const SOURCECODE_LINK = 'https://github.com/Priceincoding/priceincoding.github.io';

/* Socials */
const GITHUB_LINK = 'https://github.com/Priceincoding';
const INS_LINK = 'https://www.instagram.com/garbagedriver/';
const TWITTER_LINK = 'https://twitter.com/trashdrivr';

const App = () => (
  <Router>
    <div className="container">
      <header className="header">
        <NavLink exact className="nav-logo" activeClassName="nav-link-active" to="/">BF</NavLink>
        {/* <ul className="nav-link">
          <li><NavLink activeClassName="nav-link-active" to="/link">dmmy1</NavLink></li>
          <li><NavLink activeClassName="nav-link-active" to="/contact">dmmy2</NavLink></li>
        </ul> */}
      </header>
      <Switch>
        <Route path="/">
          <Home />
        </Route>
      </Switch>

      <footer className="footer">
        <div className="sub-footer-container">
          <ul>
            <div className="sub-footer-section-title">
              Links
            </div>
            <li>
              <a href={SOURCECODE_LINK}>
                Source Code
              </a>
            </li>
          </ul>
          <ul>
            <div className="sub-footer-section-title">
              Socials
            </div>
            <li>
              <a href={GITHUB_LINK}>
                Github
              </a>
            </li>
            <li>
              <a href={INS_LINK}>
                Instagram
              </a>
            </li>
            <li>
              <a href={TWITTER_LINK}>
                Twitter
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-container">
          2020 BF. Unfortunately I do not have a trademark D:
        </div>
      </footer>
    </div>
  </Router>
  
);

export default App;
